import { render } from "./Cookies.vue?vue&type=template&id=c6d31ea0&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=c6d31ea0&lang=scss"
import "./Cookies.vue?vue&type=style&index=1&id=c6d31ea0&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src606337513/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6d31ea0"]])

export default __exports__